import "../src/global/global-mobile"

import "@modules/location/LocationSelector"
import "@modules/solads/solads"

import "@modules/vue-modals/ad-free"
import "@modules/vue-modals/age-verification"
import "@modules/vue-modals/coins"

import "@modules/stars/styles.css"
import "@modules/stars/my-posts/mobile.css"
import "@modules/stars/stars-post"
import "@modules/stars/not-logged-in-box.css"

import StarsPost from "@modules/stars/stars-post/StarsPost"

const posts = new StarsPost(this)

posts.loadCurrentStarsPostsFilterForMyPosts()
